import React, {useCallback, useEffect, useState} from "react";
import {Box, Sheet} from "zmp-ui";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {sendRequestAuth} from "api/api";
import {Text} from "../../../../component/text";
import {Button} from "../../../../component/button";
import styled from 'styled-components'
import {ICON_DTP} from "../../../../interfaces/icon";
import {CONFIG} from "../../../../api/config";
import {useSearchParams} from "react-router-dom";
import {attributesState, cartState, attributesOriginState} from "../../../../state";
import {formatMoney} from "../../../../component/display/price";
import QuantityField from "../../../../component/inputQuantity";
import {debounce} from "@mui/material";
import {useCartProduct} from "../../hooks/useCartProduct";

export const SheetDeliveryStrange = ({sheetVisible, onDisplay}) => {

   const [searchParams] = useSearchParams()
   const orderId = searchParams.get('id') || ''
   const hashOrder = searchParams.get('hash') || ''
   const attributes = useRecoilValue(attributesState)
   const setAttributes = useSetRecoilState(attributesState)
   const attributesOrigin = useRecoilValue(attributesOriginState)
   const setAttributesOrigin = useSetRecoilState(attributesOriginState)
   const cart = useRecoilValue(cartState);
   const [attributesActive, setAttributesActive] = useState()
   const setCart = useSetRecoilState(cartState)
   const {func} = useCartProduct()
   const product = cart.find(item => item.product_id_details === sheetVisible?.product?.product_id_details)
   const debounceQuantityChange = useCallback(debounce((newProduct) => {
      func.updateProductOfOrder(newProduct)
   }, 1000), [])

   const handleQuantityChange = (amount) => {
      if (amount === 0) {
         const newProduct = cart.filter((item) => item.product_id_details !== product.product_id_details)
         setCart(newProduct)
         debounceQuantityChange(newProduct)
      } else {
         const newProduct = cart.map((item) => {
            if (item.product_id_details === product.product_id_details) {
               return {
                  ...item,
                  quantity: amount > 9999 ? item.quantity : amount,
                  total_price: amount > 9999 ? +item.quantity * +item.price : +amount * +item.price,
               }
            }
            return item
         })
         setCart(newProduct)
         debounceQuantityChange(newProduct)
      }
   }

   const getListSchool = async () => {
      const response = await sendRequestAuth(
         "get",
         `${CONFIG.API}/order/attributes-product/${sheetVisible?.product?.product_id}?order_id=${orderId}&hash=${hashOrder}`,
         "",
      );
      return response;
   };
   useEffect(() => {
      if (!!sheetVisible?.product?.product_id) {
         const response = getListSchool();
         response.then((res) => {
            if (res?.data?.data?.length > 0) {
               setAttributes(res.data?.data)
               setAttributesOrigin(res?.data?.data)
            }
         });
         const tmpAttr = cart.find(item => item?.product_id_details == sheetVisible?.product?.product_id_details)?.result_attr || []
         setAttributesActive(tmpAttr)
      }
   }, [sheetVisible]);

   // Hàm tìm và thay thế object trong mảng
   const replaceObjectInArray = (attributes, newAttribute) => {
      // const nullAttr = attributes.find(attr => !attr?.value) // tìm kiếm attribute trống trong mảng
      // if (!!nullAttr) {
      //    // nếu có attr trống thực hiện chèn attr mới vào mảng
      //    const index = attributes.findIndex(obj => obj?.attribute_id == newAttribute?.attribute_id);
      //    if (index !== -1) {
      //       const newArray = [...attributes];
      //       newArray[index] = newAttribute;
      //       return newArray;
      //    }
      // } else {
      //    // ngược lại users đã chọn full attr -> chèn attr mới vào mảng và clear các attr khác
      //
      //    const newArr = attributes.map((attr) => {
      //       if (attr?.attribute_id == newAttribute?.attribute_id) {
      //          return newAttribute
      //       }
      //       return {
      //          attribute_id: attr?.attribute_id,
      //          value: ''
      //       }
      //    })
      //    return newArr;
      //
      // }
      // nếu có attr trống thực hiện chèn attr mới vào mảng
      const index = attributes.findIndex(obj => obj?.attribute_id == newAttribute?.attribute_id);
      if (index !== -1) {
         const newArray = [...attributes];
         newArray[index] = newAttribute;
         return newArray;
      }
      return attributes;
   };

   const handleAttributeChange = value => {
      const newActiveAttr = replaceObjectInArray(attributesActive, value)
      // const nullAttr = newActiveAttr.find(attr => !attr?.value)
      // if (!!!nullAttr?.value) // nếu list Attribute mới có full thuốc tính thì không thực hiện kiểm tra nữa
      checkAttributeDisable(newActiveAttr, value)
   }
   const checkAttributeDisable = async (attr_value, value) => {
      const response = await sendRequestAuth(
         "post",
         `${CONFIG.API}/order/check-attributes-disable/${sheetVisible?.product?.product_id}`,
         JSON.stringify({
            "order_id": orderId,
            "hash": hashOrder,
            "attr_value": attr_value
         }),
      );
      if (response.data.success) {
         const disableAttrs = response?.data?.data
         if (disableAttrs.length > 0) {
            let tempAttr = [...attributesOrigin]
            let tempAttrActive = [...attr_value]
            disableAttrs.map((dAttr, index) => {
               if (!!dAttr[0] && dAttr[0] === tempAttrActive[index]?.value && dAttr[0] !== value?.value) {
                  tempAttrActive[index] = {
                     ...tempAttrActive[index],
                     value: ''
                  }
               }
               if (!!dAttr[0] && tempAttr[index]?.arr_attr_value?.length > 0) {
                  tempAttr[index] = {
                     ...tempAttr[index],
                     arr_attr_value: tempAttr[index].arr_attr_value.map(item => {
                        if (item.name === dAttr[0]) return {
                           ...item,
                           disable: true
                        }
                        return item
                     })
                  }
               }
            })

            setAttributesActive(tempAttrActive)
            setAttributes(tempAttr)
         } else {
            setAttributes(attributesOrigin)
            setAttributesActive(attr_value)
         }
      }
   }

   const getProductWithAttribute = async () => {
      const response = await sendRequestAuth(
         "post",
         `${CONFIG.API}/order/product/${sheetVisible?.product?.product_id}`,
         JSON.stringify({
            "order_id": orderId,
            "hash": hashOrder,
            "attr_value": attributesActive
         }),
      );
      return response
   }
   const [waitingSubmit, setWaitingSubmit] = useState(false)
   const confirmChangeProductVersion = _ => {
      if (!!waitingSubmit) return
      setWaitingSubmit(true)
      const response = getProductWithAttribute()
      response.then(res => {
         if (res?.data?.success) {
            let cartDetail = null
            setWaitingSubmit(false)
            const productVersion = res.data?.data

            //check version đã có trong cart hay chưa
            cartDetail = cart.find(c => c.product_id_details === productVersion?.id) || null

            if(cartDetail?.id){
               let oldProduct = cart.find(c => c.product_id_details === sheetVisible?.product?.product_id_details)
               let cartTemp = cart.filter(c => c.product_id_details !== sheetVisible?.product?.product_id_details)
               cartTemp = cartTemp.map(item => {
                  if(item?.product_id_details === productVersion?.id){
                     return {
                        ...item,
                        quantity: +item?.quantity + +oldProduct?.quantity,
                        total_price:  +item?.price * (+item?.quantity + +oldProduct?.quantity),
                     }
                  }
                  return item
               })
               setCart(cartTemp)
            }else{

               cartDetail = cart.find(c => c.product_id === productVersion?.product_id) || null
               const newVersion = {
                  "id": cartDetail?.id,
                  "product_id": productVersion?.product_id || '',
                  "product_id_details": productVersion.id || '',
                  "product_name": productVersion?.product_name || '',
                  "parent_product_name": cartDetail?.parent_product_name || '',
                  "product_model": productVersion?.product_model || '',
                  "unit_name": cartDetail?.unit_name,
                  "quantity": cartDetail?.quantity,
                  "price": productVersion?.price || '',
                  "total_price": +productVersion?.price * +cartDetail?.quantity,
                  "image_thumb": productVersion?.image_thumb || '',
                  // "attr_value_1": "10007",
                  // "attr_value_2": "10008",
                  // "attr_value_3": "10009",
                  "result_attr": productVersion?.result_attr || []
               }
               const index = cart.findIndex(c => c.product_id === productVersion?.product_id)
               if (index !== -1) {
                  const newCart = [...cart];
                  newCart[index] = newVersion;
                  setCart(newCart)
               }
            }
            onDisplay({display: false, product: null})
         } else {
            setWaitingSubmit(false)
         }
      })
   }

   return (
      <SheetStyled>
         <Sheet
            visible={sheetVisible?.display}
            onClose={() => onDisplay({
               display: false, product: null
            })}
            autoHeight
            mask
            handler
            swipeToClose
            style={{
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               background: 'transparent',
               boxShadow: 'none',
               flexDirection: 'column',
            }}
         >
            <Box flex alignItems={'start'} justifyContent={'space-between'} className={'sheet-header'}
                 style={{width: window.innerWidth, maxWidth: 500}}>
               <Box flex alignItems={'start'} justifyContent={'space-between'}
                    style={{width: window.innerWidth, maxWidth: 500, borderBottom: '1px solid #DAE4F6'}}>
                  <Box pb={4} style={{width: '85%'}}>
                     <Text as={'p'} fontSize={16} lineHeight={'140%'}>{sheetVisible?.product?.parent_product_name}</Text>
                     <Text as={'p'} fontSize={18} fontWeight={600} color={'#FF424F'}
                           lineHeight={'140%'}>{formatMoney(sheetVisible?.product?.price)}đ</Text>
                  </Box>
                  <Box style={{cursor: 'pointer'}} onClick={() => onDisplay({
                     display: false, product: null
                  })}>
                     {ICON_DTP.close}
                  </Box>
               </Box>
            </Box>
            <Box p={6} className="custom-bottom-sheet" flex flexDirection="column"
                 style={{
                    maxWidth: 500,
                    minWidth: 320,
                    background: '#fff',
                    // borderRadius: '16px 16px 0 0',
                    // boxShadow: '0px -2px 6px 0px #14141524',
                 }}>
               <Box style={{width: window.innerWidth - 48, maxWidth: 452}}></Box>
               <Box flex flexDirection="column" mb={4} justifyContent="center">
                  {
                     attributes.length > 0 && attributes.map((attr) => {
                        return (

                           <Box key={attr.id}>
                              <Text as={'p'} fontWeight={500} style={{marginBottom: 12}}>{attr.name}</Text>
                              <Box flex flexWrap={'wrap'} style={{flexWrap: 'wrap'}}>
                                 {
                                    attr?.arr_attr_value?.length > 0 && attr.arr_attr_value.map(
                                       (value, index) => (
                                          <Box className={'p-[10px] item-attribute'} key={index}
                                               onClick={() => {
                                                  if (!!!value?.disable)
                                                     handleAttributeChange({
                                                        value: value?.name,
                                                        attribute_id: attr.id
                                                     })
                                               }
                                               }
                                               data-active={!!attributesActive?.find(item => item?.value == value?.name)}
                                               data-disable={!!value?.disable}>
                                             <Text>{value?.name}</Text>
                                          </Box>
                                       )
                                    )
                                 }
                              </Box>
                           </Box>
                        )
                     })
                  }
               </Box>
               <Box flex flexDirection="column" mt={2}
                    style={{width: '100%', position: 'sticky', bottom: -20}}>
                  <Box flex justifyContent={'space-between'} className={'mb-6'}>
                     <Text fontWeight={500} as={'p'} style={{width: 'calc(100% - 104px)'}}>Số lượng</Text>
                     <QuantityField {...{
                        handleQuantityChange,
                        product,
                     }} />
                  </Box>
                  <Button size={'lg'} style={{width: '100%'}}
                          onClick={confirmChangeProductVersion}
                          disabled={!!attributesActive?.find(item => !!!item.value)}>Xác nhận</Button>
               </Box>
            </Box>
         </Sheet>
      </SheetStyled>
   );
};

const SheetStyled = styled.div`
   .sheet-header{
    background: #fff;
    padding: 24px 24px 0 24px;
    max-width: 500px;
    border-radius: 16px 16px 0px 0px;
   }
   .item-attribute{
      border-radius: 4px;
      border: 1px solid #DAE4F6;
      margin-right: 8px;
      margin-bottom: 8px;
      padding: 4px 10px;
      :hover{
        cursor: pointer;
        border-color: #1E9A98;
        span{
          color: #1E9A98!important;
          font-weight: 500;
        }
      }
      &[data-disable=true]{
        background: #dae4f6;
        cursor: not-allowed;
        span{
          color: #999ca1 !important;
          font-weight: 500;
        }
        &:hover{
           span{
             border-color: #999ca1!important;
             color: #999ca1!important;
             font-weight: 500;
           }
         }
      }
      &[data-active=true]{
        cursor: pointer;
        border-color: #1E9A98;
        background: #fff;
        span{
          color: #1E9A98!important;
          font-weight: 500;
        }
      }
   }
`